/**
 * Profile-level hour tag notes above the chart: the tags could not be read,
 * or a rule tests a tag no enabled Tag Rules › Hours rule has — either way
 * those conditions do nothing, and the operator is told which.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { FC } from 'react';
import { AlertTriangle } from 'lucide-react';
import type { DropGenHourProfile } from '@trafficpulse/shared';

const Note: FC<{ text: string }> = ({ text }) => (
  <p className="flex items-start gap-1.5 rounded-lg border border-warning/40 bg-warning/5 px-3 py-2 text-xs text-foreground">
    <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-warning" aria-hidden />
    {text}
  </p>
);

export const HourTagNotes: FC<{ profile: Pick<DropGenHourProfile, 'tagsUnavailable' | 'missingTags'> }> = ({ profile }) => {
  const missing = profile.missingTags ?? [];
  return (
    <>
      {profile.tagsUnavailable ? (
        <Note text="The hour tags could not be read — rules that test a tag do nothing until they load." />
      ) : null}
      {missing.length > 0 ? (
        <Note text={`No enabled hour tag is named ${missing.map((n) => `"${n}"`).join(', ')} — those conditions do nothing. Pick another tag or re-create it on Tag Rules › Hours.`} />
      ) : null}
    </>
  );
};
